import { useState } from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import DotChartInfoTab from '../dotChartInfoTab';
import { jobData } from '@domain/constant/v1/jobType';
import classnames from 'classnames/bind';
import styles from './dotChartInfo.module.scss';

const cx = classnames.bind(styles);

const MARGIN_LEFT = 32;
const SLIDER_CONTENTS_WIDTH = 552;

interface DotChartInfo {
  activeIndex: number;
  recommend: 'recommend' | 'notRecommend' | 'common';
}

const DotChartInfo = ({ activeIndex, recommend }: DotChartInfo) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [itemsEls, setItemsEls] = useState<HTMLLIElement[]>([]);

  const clearTab = () => {
    setCurrentItemIndex(0);
    setScrollOffset(0);
    setItemsEls([]);
  };

  const updateCurrentItemIndex = (value: number) => {
    if (value < 0 || value >= itemsEls.length) return;
    setCurrentItemIndex(value);

    let listWidth = 0;
    let listLeftWidth = 0;
    let listRightWidth = 0;

    itemsEls.forEach((item, index) => {
      listWidth += item.offsetWidth + MARGIN_LEFT;
      if (index < value) {
        listLeftWidth += item.offsetWidth + MARGIN_LEFT;
      } else if (index >= value) {
        listRightWidth += item.offsetWidth + MARGIN_LEFT;
      }
    });

    if (listWidth <= SLIDER_CONTENTS_WIDTH) return;

    if (listRightWidth > SLIDER_CONTENTS_WIDTH + 30) {
      setScrollOffset(-listLeftWidth);
    } else {
      setScrollOffset(-(listWidth - SLIDER_CONTENTS_WIDTH - MARGIN_LEFT));
    }
  };

  const { accaResultStore } = useResultStore();
  const { accJobCuration } = accaResultStore;

  if (!accJobCuration) return null;

  const { jobRankings } = accJobCuration;

  if (!jobRankings) return null;

  const recommendText = recommend === 'recommend' ? '추천' : recommend === 'notRecommend' ? '고민 필요' : '보통';
  const color = recommend === 'recommend' ? 'green' : recommend === 'notRecommend' ? 'red' : 'gray';
  const title = jobRankings[activeIndex]?.jobGroup?.name;
  const code = jobRankings[activeIndex]?.jobGroup?.code;
  const listData = jobData[code];
  const desc = currentItemIndex >= 0 && listData && listData[currentItemIndex]?.desc;

  if (activeIndex < 0) {
    return (
      <div className={cx('dotChartInfo', 'empty')}>
        위 도표에서 직군명을 클릭하시면 이곳에 자세한 정보를 보여드려요!
      </div>
    );
  }

  return (
    <div className={cx('dotChartInfo')}>
      <span className={cx('recommend', color)}>{recommendText}</span>
      <em className={cx('title')}>{title}</em>
      <div className={cx('tabWrap')}>
        <DotChartInfoTab
          listData={listData}
          currentItemIndex={currentItemIndex}
          updateCurrentItemIndex={updateCurrentItemIndex}
          clearTab={clearTab}
          itemsEls={itemsEls}
          scrollOffset={scrollOffset}
        />
      </div>
      <p className={cx('desc')}>{desc}</p>
    </div>
  );
};

export default DotChartInfo;
